import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ProjectCardProps as Props } from './types'
import styles from './ProjectCard.module.scss'
import Link from 'next/link'
import { routes } from 'utils/routes'
import { useRouter } from 'next/router'
import Button from 'components/button/Button'
import classNames from 'classnames'

const ProjectCard: FC<Props> = ({ project, hasButton }) => {
  // I18N
  const { t } = useTranslation('projects')

  // Next router
  const { locale } = useRouter()

  // Constants
  const { title, description, image, linkKey, category } = project

  return (
    <Link href={routes(locale)[linkKey]}>
      <div className={styles['project-card']}>
        <div className={styles['card-image-wrapper']}>
          <div className={styles['card-image']} style={{ backgroundImage: `url(/images/components/projects/${image})` }} />
        </div>

        <div className={styles['card-content']}>
          <div className={styles.category}>{t(category.key, category.default)}</div>

          <h3 className={classNames('title', styles.title)}>{t(title.key, title.default)}</h3>

          <div className={classNames(styles.description, { 'margin-bottom-m': hasButton })}>{t(description.key, description.default)}</div>

          {hasButton && (
            <Button isFullWidthMobile withGradient>
              {t('projectButton', 'Lees meer')}
            </Button>
          )}
        </div>
      </div>
    </Link>
  )
}

ProjectCard.defaultProps = {
  hasButton: true
}

export default ProjectCard
